import React from 'react';
import Styled from './styles';
import { Button, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FormControl } from 'material-ui';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import api from '../../../lib/api';
import moment from 'moment';

const styles = theme => ({
  textField: {
    marginRight: theme.spacing.unit,
    width: 276,
    border: '1px solid #C4C4C4',
    borderRadius: '5px',
    padding: '10px'
  },
  input: {
    fontSize: 16,
    fontWeight: 'normal',
    '&[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  button: {
    backgroundColor: '#42FFBB',
    color: 'black',
    fontSize: 14,
    fontWeight: 900,
    borderRadius: 8,
    padding: '15px',
    '&:hover': {
      backgroundColor: '#42FFBB'
    }
  }
});

class ExtendPaymentLink extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showSnackBar: false,
      paymentLink: '',
      companyName: '',
      validDate: '',
      validTime: '',
      pan: '',
      gstn: '',
      updatedValidDate: '',
      updatedValidTime: '',
      expiryTime: '',
      message: '',
      errorPaymentLink: false,
      errorValidDate: false,
      errorValidTime: false,
      errorSavePaymentLink: false,
      disableTextField: true,
      loading: false
    };
  }
  paymentLinkChange = e => {
    const updatedState = !e.target.value
      ? {
          companyName: '',
          validDate: '',
          validTime: ''
        }
      : { paymentLink: e.target.value, errorPaymentLink: false };

    this.setState(updatedState);
  };

  getLinkValidityDetails = async e => {
    e.preventDefault();
    e.stopPropagation();

    if (!e.target.value) {
      return;
    }

    try {
      this.setState({ loading: true, disableTextField: true });
      const {
        target: { value }
      } = e;
      const paymentLink = value.split('/').slice(-1)[0];
      const {
        companyName,
        expiryTime,
        gst,
        pan
      } = await api.getLinkValidityDetails(paymentLink);

      const expiryDateMomentObject = moment(expiryTime);
      const dateFromMomentObject = expiryDateMomentObject
        .clone()
        .format('YYYY-MM-DD');
      const timeFromMomentObject = expiryDateMomentObject
        .clone()
        .format('HH:mm');

      this.setState({
        companyName: companyName,
        validDate: dateFromMomentObject,
        validTime: timeFromMomentObject,
        gstn: gst || '',
        pan: pan || '',
        loading: false,
        disableTextField: false
      });
    } catch (error) {
      this.setState({
        companyName: '',
        validDate: '',
        validTime: '',
        pan: '',
        gstn: '',
        loading: false,
        disableTextField: true,
        errorPaymentLink: true
      });
    }
  };

  onPanChange = event => {
    const { value } = event.target;
    this.setState({ pan: value, errorPan: false });
  };
  onGstnChange = event => {
    const { value } = event.target;
    this.setState({ gstn: value, errorGstn: false });
  };
  onDateChange = event => {
    const { value } = event.target;
    this.setState({ updatedValidDate: value });
    if (
      moment()
        .startOf('day')
        .isAfter(moment(value).startOf('day'))
    ) {
      this.setState({ errorValidDate: true });
      return;
    }
    this.calcExpiryTime(value, this.state.updatedValidTime);
    this.setState({ errorValidDate: false, updatedValidDate: value });
  };
  onTimeChange = e => {
    const { value } = e.target;
    this.setState({ updatedValidTime: value, errorValidTime: false });
    this.calcExpiryTime(this.state.updatedValidDate, value);
  };
  calcExpiryTime = (date, time) => {
    if (!date || !time) {
      return;
    }
    const expiryTime = moment(
      `${date}_${time}`,
      'YYYY-MM-DD_HH:mm'
    ).toISOString();
    this.setState({ expiryTime });
  };

  cleanState = () => {
    this.setState({
      paymentLink: '',
      companyName: '',
      validDate: '',
      validTime: '',
      pan: '',
      gstn: '',
      updatedValidDate: '',
      updatedValidTime: '',
      expiryTime: '',
      errorPaymentLink: false,
      errorValidDate: false,
      errorValidTime: false,
      errorSavePaymentLink: false,
      disableTextField: true,
      loading: false
    });
  };
  validateForm = () => {
    let errorFlag = false;
    if (!this.state.paymentLink || this.state.errorPaymentLink) {
      errorFlag = true;
      this.setState({ errorPaymentLink: true });
    }
    // if (!this.state.updatedValidDate) {
    //   errorFlag = true;
    //   this.setState({ errorValidDate: true });
    // }
    // if (!this.state.updatedValidTime) {
    //   errorFlag = true;
    //   this.setState({ errorValidTime: true });
    // }

    return errorFlag;
  };
  onSavePaymentLink = async () => {
    this.setState({
      errorPaymentLink: false
    });
    let errorFlag = this.validateForm();
    if (errorFlag) {
      return;
    }
    let paymentLink = this.state.paymentLink.split('/').slice(-1)[0];
    let expiryTime = this.state.expiryTime;
    const sendGstnOrPan = () => {
      if (this.state.pan) {
        return { pan: this.state.pan };
      }
      if (this.state.gstn) {
        return { gst: this.state.gstn };
      }
    };
    try {
      await api.savePaymentLink({
        paymentLink,
        ...(expiryTime && { expiryTime }),
        ...sendGstnOrPan()
      });
      this.setState({
        message: 'Payment Link Extended Successfully',
        showSnackBar: true,
        errorSavePaymentLink: false
      });
      this.cleanState();
    } catch (error) {
      console.log(error.response.statusText);
      this.setState({
        errorSavePaymentLink: true
      });
    }
  };
  onSnackbarClose = () => {
    this.setState({ showSnackBar: false, message: '' });
  };
  renderSnackbarMessage = () => {
    const { message } = this.state;
    return <Styled.SnackbarMessage>{message}</Styled.SnackbarMessage>;
  };
  render() {
    const { classes } = this.props;
    return (
      <Styled.ExtendPaymentLinkContainer>
        <Styled.Title>Payment link generator</Styled.Title>
        <FormControl>
          <Styled.LabelAndTextField>
            <Styled.Label>Enter payment link</Styled.Label>
            <Styled.InputField>
              <TextField
                id="PaymentLink"
                type="text"
                autoComplete="off"
                className={classes.textField}
                onBlur={this.getLinkValidityDetails}
                onChange={this.paymentLinkChange}
                value={this.state.paymentLink}
                InputProps={{
                  disableUnderline: true,
                  classes: { input: classes.input }
                }}
                margin="normal"
              />
              {this.state.errorPaymentLink && (
                <Styled.Error>Invalid PaymentLink</Styled.Error>
              )}
            </Styled.InputField>
            {this.state.loading && (
              <Styled.LoaderContainer>
                <CircularProgress size={20} thickness={5} color="primary" />
              </Styled.LoaderContainer>
            )}
          </Styled.LabelAndTextField>
          <Styled.VerifyDetailsContainer>
            Please verify details:
            <Styled.DetailContainer>
              <Styled.DetailTitle>Company Name:</Styled.DetailTitle>
              <Styled.Label>{this.state.companyName}</Styled.Label>
            </Styled.DetailContainer>
            <Styled.DetailContainer>
              <Styled.DetailTitle>Valid date:</Styled.DetailTitle>
              <Styled.Label>{this.state.validDate}</Styled.Label>
            </Styled.DetailContainer>
            <Styled.DetailContainer>
              <Styled.DetailTitle>Valid time:</Styled.DetailTitle>
              <Styled.Label>{this.state.validTime}</Styled.Label>
            </Styled.DetailContainer>
          </Styled.VerifyDetailsContainer>
          <Styled.LabelAndTextField>
            <Styled.Label>PAN</Styled.Label>
            <FormControl>
              <TextField
                disabled={this.state.disableTextField || !!this.state.gstn}
                id="pan"
                autoComplete="off"
                type="text"
                className={classes.textField}
                style={{
                  backgroundColor: this.state.gstn ? 'lightgray' : 'white'
                }}
                onChange={this.onPanChange}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: { input: classes.input }
                }}
                value={this.state.pan}
              />
              {!!this.state.gstn && (
                <Styled.Error>
                  Disabled as only GSTN or PAN can be used at once{' '}
                </Styled.Error>
              )}
            </FormControl>
          </Styled.LabelAndTextField>

          <Styled.LabelAndTextField>
            <Styled.Label>GSTN</Styled.Label>
            <FormControl>
              <TextField
                disabled={this.state.disableTextField || !!this.state.pan}
                id="gstn"
                autoComplete="off"
                type="text"
                className={classes.textField}
                style={{
                  backgroundColor: this.state.pan ? 'lightgray' : 'white'
                }}
                onChange={this.onGstnChange}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: { input: classes.input }
                }}
                value={this.state.gstn}
              />
              {!!this.state.pan && (
                <Styled.Error>
                  Disabled as only GSTN or PAN can be used at once{' '}
                </Styled.Error>
              )}
            </FormControl>
          </Styled.LabelAndTextField>

          <Styled.LabelAndTextField>
            <Styled.Label>Valid Date</Styled.Label>
            <FormControl>
              <TextField
                disabled={this.state.disableTextField}
                id="date"
                autoComplete="off"
                type="date"
                className={classes.textField}
                onChange={this.onDateChange}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: { input: classes.input }
                }}
                value={this.state.updatedValidDate}
              />
              {this.state.errorValidDate && (
                <Styled.Error>Invalid Date</Styled.Error>
              )}
            </FormControl>
          </Styled.LabelAndTextField>
          <Styled.LabelAndTextField>
            <Styled.Label>Valid Time</Styled.Label>
            <FormControl>
              <TextField
                disabled={this.state.disableTextField}
                id="time"
                autoComplete="off"
                type="time"
                value={this.state.updatedValidTime}
                onChange={this.onTimeChange}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: { input: classes.input }
                }}
              />
              {this.state.errorValidTime && (
                <Styled.Error>Time Field is empty</Styled.Error>
              )}
            </FormControl>
          </Styled.LabelAndTextField>
          <Styled.LabelAndTextField>
            <Styled.InputField>
              <Button
                tabIndex="-1"
                type="submit"
                classes={{ root: classes.button }}
                onClick={this.onSavePaymentLink}
              >
                SAVE PAYMENT LINK
              </Button>
              {this.state.errorSavePaymentLink && (
                <Styled.Error>Something went wrong </Styled.Error>
              )}
            </Styled.InputField>
          </Styled.LabelAndTextField>
        </FormControl>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          open={this.state.showSnackBar}
          onClose={this.onSnackbarClose}
          autoHideDuration={3000}
          message={this.renderSnackbarMessage()}
          action={[
            <IconButton key={0} onClick={this.onSnackbarClose}>
              <CloseIcon nativeColor="#fff" />
            </IconButton>
          ]}
        />
      </Styled.ExtendPaymentLinkContainer>
    );
  }
}

export default withStyles(styles)(ExtendPaymentLink);



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/ExtendPaymentLink/index.js